import React from 'react';

import CardSecurityCodeIcon from './card-security-code.svg';

export default props => <img {...props} src={CardSecurityCodeIcon} alt="" />;
